// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__lJiDT","crumb":"styles_crumb__FOtEp","label":"styles_label__hGfhb","icon":"styles_icon__gwRo3"};